import { TypeSettingsValueProps } from 'src/@types';

const defaultSettings: TypeSettingsValueProps = {
  themeMode: 'light',
  themeColorPresets: 'default',
  themeStretch: false
};

export default defaultSettings;
